/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/require-default-props */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import {
 Box,
 Checkbox,
 FormControl,
 FormControlLabel,
 InputLabel,
 MenuItem,
 Select,
 TextField,
 Theme,
 Typography,
 useTheme,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { StructureType } from '../../../types/types';
import { isJson } from '../../../utils/dataTypes';
import SelectApi from '../SelectApi';
import { useTranslation } from 'react-i18next';
import { usePage } from '../../../contexts/usePageContext';
import { getModelInfo, isWeightModelField } from '@/utils/structureUtils';
const boxStyles = {
 display: 'flex',
 flexDirection: 'column',
 gap: 2,
};

type GroupedFields = StructureType & {
 Key: string;
 Translation: string;
 Group: string;
};

const EditFields = ({
 fieldsWithData,
 activeTabName,
 type = 'regular',
}: {
 fieldsWithData: GroupedFields[];
 activeTabName?: string;
 type?: 'array' | 'regular';
}) => {
 const {
  control,
  formState: { errors },
  setValue,
 } = useFormContext();
 const { t } = useTranslation();
 const th = useTheme();
 const { pageName } = usePage();
 const inputStyles = {
  backgroundColor: th.palette.kemek.white,
  '& .MuiInputBase-root': {
   backgroundColor: th.palette.kemek.white,
  },
 };

 const groups = useMemo(() => {
  const showEmptyGroup = false;
  const sortedFields =
   pageName === 'results'
    ? fieldsWithData || []
    : fieldsWithData?.sort((a, b) => a.Priority - b.Priority) || [];
  const groupedByTab: Record<string, Record<string, GroupedFields[]>> = {};
  const regularGroups: Record<string, GroupedFields[]> = {};

  sortedFields.forEach((f) => {
   if (!showEmptyGroup && f.Group === null) {
    return;
   }
   const normalizedGroup =
    pageName === 'results' ? '' : f.Group === null ? 'EMPTY GROUP!' : f.Group;
   const groupPattern = /^(.+?)_(.+)$/;
   const match = normalizedGroup?.match(groupPattern);

   if (match) {
    const [, tabName, groupName] = match;
    if (!groupedByTab[tabName]) {
     groupedByTab[tabName] = {};
    }
    if (!groupedByTab[tabName][groupName]) {
     groupedByTab[tabName][groupName] = [];
    }
    groupedByTab[tabName][groupName].push(f);
   } else {
    regularGroups[normalizedGroup] = regularGroups[normalizedGroup] || [];
    regularGroups[normalizedGroup].push(f);
   }
  });

  if (activeTabName && groupedByTab[activeTabName]) {
   return {
    groups: {},
    tabs: { [activeTabName]: groupedByTab[activeTabName] },
   };
  }

  return { groups: regularGroups, tabs: groupedByTab };
 }, [fieldsWithData, activeTabName, pageName]);

 const renderFields = (fields: GroupedFields[]) => {
  return fields?.map((f) => {
   //  if (!f.IsEditable) return false;
   if (!f.IsViewable) return false;

   if (f.Name === 'ResultProducts' || f.Type === 'array') {
    // return false;
   }
   if (isWeightModelField(f)) {
    return (
     <Controller
      key={`${f.Key}`}
      name={f.Key}
      control={control}
      render={({ field }) => {
       const weightValue =
        typeof field.value === 'object' && field.value !== null
         ? field.value.Weight ?? ''
         : field.value ?? '';
       return (
        <TextField
         {...field}
         sx={inputStyles}
         disabled={!f.IsEditable}
         onChange={(e) => {
          const onlyNums = e.target.value.replace(/[^0-9]/g, '');
          field.onChange(onlyNums);
         }}
         slotProps={{
          input: {
           inputMode: 'numeric',
          },
         }}
         type="number"
         value={weightValue}
         label={f.Translation}
         variant="outlined"
         error={!!errors?.[f.Key]}
         fullWidth
        />
       );
      }}
     />
    );
   }
   if (f.Type === 'model') {
    return f.ForeignKeyUrl ? (
     <Box key={`${f.Key}`}>
      {f.ForeignKeyUrl !== 'not supported' ? (
       <SelectApi
        name={f.Name}
        url={f.ForeignKeyUrl}
        filter={f.ForeignKeyDefaultFilter}
        label={f.Translation}
        isEditable
        styles={inputStyles}
        disabled={!f.IsEditable}
        operator={
         ['int32', 'decimal', 'double'].includes(
          f.InnerStructure.find(
           (s) => s.Name === getModelInfo(f.ForeignKeyDefaultFilter).name,
          )?.Type || 'string',
         )
          ? 'eq'
          : 'contains'
        }
        control={control}
        setValue={setValue}
       />
      ) : (
       <Box key={`${f.Key}`}>{f.Name} ForeignKeyUrl not supported</Box>
      )}
     </Box>
    ) : (
     <Box
      sx={{
       ...boxStyles,
       color: (theme: Theme) => theme.palette.kemek.red,
      }}
      key={`${f.Key}`}
     >
      {f.Key}: ForeignKeyUrl not found
     </Box>
    );
   }
   if (f.Type === 'datetime') {
    return (
     <Controller
      key={`${f.Key}`}
      name={f.Key}
      control={control}
     render={({ field }) => {
      const isEmpty = [undefined, null, ''].includes(field.value);
      return (
       <DateTimePicker
        {...field}
        disabled={!f.IsEditable}
        views={['year', 'month', 'day', 'hours', 'minutes']}
        sx={inputStyles}
        defaultValue={isEmpty ? null : dayjs(field.value)}
        value={isEmpty ? null : dayjs(field.value)}
        label={f.Translation}
        slotProps={{
         textField: {
          error: !!errors?.[f.Key],
         },
        }}
       />
      );
     }}
     />
    );
   }
   if (f.Type === 'array') {
    return (
     <Box key={`${f.Key}`}>
      {f.ForeignKeyUrl !== 'not supported' ? (
       <SelectApi
        name={f.Name}
        url={f.ForeignKeyUrl}
        filter={f.ForeignKeyDefaultFilter}
        label={f.Translation}
        isEditable
        styles={inputStyles}
        disabled={!f.IsEditable}
        operator={
         ['int32', 'decimal', 'double'].includes(
          f.InnerStructure.find(
           (s) => s.Name === getModelInfo(f.ForeignKeyDefaultFilter).name,
          )?.Type || 'string',
         )
          ? 'eq'
          : 'contains'
        }
        control={control}
        setValue={setValue}
       />
      ) : (
       <Box key={`${f.Key}`}>{f.Name} ForeignKeyUrl not supported</Box>
      )}
     </Box>
    );
   }
   if (f.Type === 'boolean') {
    return (
     <Controller
      key={`${f.Key}`}
      name={f.Key}
      control={control}
      render={({ field }) => (
       <FormControlLabel
        control={
         <Checkbox
          {...field}
          disabled={!f.IsEditable}
          checked={field.value || false}
          onChange={(e) => field.onChange(e.target.checked)}
         />
        }
        label={f.Translation}
       />
      )}
     />
    );
   }

   if (f.Type === 'enum') {
    return (
     <FormControl key={`${f.Key}`}>
      <InputLabel htmlFor={f.Name}>{f.Translation}</InputLabel>
      <Controller
       name={f.Key}
       control={control}
       render={({ field }) => {
        return (
         <Select
          {...field}
          sx={inputStyles}
          id={f.Name}
          disabled={!f.IsEditable}
          onChange={(e: any) => {
           setValue(f.Key, e.target.value || '', {
            shouldValidate: true,
           });
          }}
          value={field.value ?? ''}
          label={f.Translation}
          //  displayEmpty
         >
          {Object.entries(f.EnumValues).map(([value, label]) => (
           <MenuItem key={value} value={value}>
            {label}
           </MenuItem>
          ))}
         </Select>
        );
       }}
      />
     </FormControl>
    );
   }
   if (['int32', 'decimal', 'double'].includes(f.Type)) {
    return (
     <Controller
      key={`${f.Key}`}
      name={f.Key}
      control={control}
      render={({ field }) => (
       <TextField
        {...field}
        sx={inputStyles}
        disabled={!f.IsEditable}
        onChange={(e) => {
         const onlyNums = e.target.value.replace(/[^0-9]/g, '');
         field.onChange(onlyNums);
        }}
        slotProps={{
         input: {
          inputMode: 'numeric',
         },
        }}
        type="number"
        value={field.value || ''}
        label={f.Translation}
        variant="outlined"
        error={!!errors?.[f.Key]}
        fullWidth
       />
      )}
     />
    );
   }
   return (
    <Controller
     key={`${f.Key}`}
     name={f.Key}
     control={control}
     defaultValue=""
     render={({ field }) => (
      <TextField
       {...field}
       sx={inputStyles}
       disabled={!f.IsEditable}
       value={field.value || ''}
       label={f.Translation}
       variant="outlined"
       error={!!errors?.[f.Key]}
       fullWidth
      />
     )}
    />
   );
  });
 };

 //  console.log('groups', groups);
 return (
  <Box>
   {Object.entries(groups.groups).map(([group, fields], i) => (
    <Box key={group}>
     {type !== 'array' ? (
      <Typography
       sx={{
        color: (theme: Theme) => theme.palette.kemek.darkGray,
        fontWeight: 500,
        fontSize: 14,
        mb: 2,
       }}
      >
       {group}
      </Typography>
     ) : (
      ''
     )}
     <Box
      sx={{
       display: 'flex',
       flexDirection: 'column',
       gap: '12px',
       mb: i === Object.entries(groups.groups).length - 1 ? 0 : 2,
      }}
     >
      {renderFields(fields)}
     </Box>
    </Box>
   ))}
   {Object.entries(groups.tabs).map(([tabName, tabGroups], index) => (
    <Box key={tabName}>
     <Typography
      sx={{
       color: (theme: Theme) => theme.palette.kemek.darkGray,
       fontWeight: 600,
       fontSize: 16,
       mb: 2,
       mt: index === 0 ? 0 : 3,
      }}
     >
      {tabName}
     </Typography>
     {Object.entries(tabGroups).map(([groupName, fields]) => (
      <Box key={`${tabName}_${groupName}`}>
       <Typography
        sx={{
         color: (theme: Theme) => theme.palette.kemek.darkGray,
         fontWeight: 500,
         fontSize: 14,
         mb: 2,
        }}
       >
        {groupName}
       </Typography>
       <Box
        sx={{ display: 'flex', flexDirection: 'column', gap: '12px', mb: 2 }}
       >
        {renderFields(fields)}
       </Box>
      </Box>
     ))}
    </Box>
   ))}
  </Box>
 );
};

EditFields.displayName = 'EditFields';
export default EditFields;
